import { render, staticRenderFns } from "./DSBellIcon.vue?vue&type=template&id=0ccadfcf&scoped=true&"
import script from "./DSBellIcon.vue?vue&type=script&lang=js&"
export * from "./DSBellIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccadfcf",
  null
  
)

export default component.exports